
import { defineComponent } from "vue";
import { IonPage, IonContent } from "@ionic/vue";

export default defineComponent({
  name: "Tab1Page",
  components: { IonContent, IonPage },
});
